<template>
  <base-section class="about-our-product">
    <base-section-heading color="grey lighten-2" icon="" :title="title" />

    <v-container>
      <v-row>
        <v-col v-for="card in cards" :key="card.title" cols="12" md="3" class="product-card" @click="goToProduct(card.id)">
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',
    props: {
      title: {
        type: String,
        default: 'About our Product'
      },
      cards: {
        type: Array,
        default: () => ([]),
      }
    },
    methods: {
      goToProduct(productId) {
        this.$router.push({ path: `/manufacture/${productId}` })
      }
    }
  }
</script>

<style lang="scss" scoped>
.product-card {
  cursor: pointer !important;

  &:hover {
    background-color: #f5f5f5;
    box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.2);
  }
}
</style>